import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LeftNav from './LeftNav';
import '../styles/Dashboard.css';
const Dashboard = ({ activeNav, onNavChange, preSurveyComplete, children }) => {
    return (_jsx("div", { className: "dashboard", children: _jsxs("div", { className: "dashboard-body", children: [_jsx(LeftNav, { activeItem: activeNav, onItemClick: onNavChange, preSurveyComplete: preSurveyComplete }), _jsx("main", { className: "dashboard-content", children: children })] }) }));
};
export default Dashboard;
